module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "page-card-margin row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v(_vm._s(_vm.web_texts.create_invoice_simulation))])]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('form', {
    staticClass: "form-horizontal ",
    attrs: {
      "id": "invoice-simulation",
      "enctype": "multipart/form-data"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-lg-4 form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.web_texts.date_range))]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2 form-group"
  }, [_c('label', {
    attrs: {
      "for": "user-name"
    }
  }, [_vm._v(_vm._s(_vm.web_texts.username))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user_name),
      expression: "user_name"
    }],
    staticClass: "form-control input-lg",
    attrs: {
      "id": "user-name",
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.user_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 form-group"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('label', {
    attrs: {
      "for": "slave_type"
    }
  }, [_vm._v(_vm._s(_vm.web_texts.device_model))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.slave_type),
      expression: "slave_type"
    }],
    staticClass: "form-control input-lg",
    attrs: {
      "id": "slave_type",
      "name": "slave_type",
      "size": "1"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.slave_type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.getDeviceNumberAndVariables()
      }]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.web_texts.select_model))]), _vm._v(" "), _vm._l((_vm.slave_types), function(slave_type) {
    return (slave_type !== 'Irrimation') ? _c('option', {
      domProps: {
        "value": slave_type
      }
    }, [_vm._v("\n                      " + _vm._s(slave_type) + "\n                    ")]) : _vm._e()
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 form-group"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('label', {
    attrs: {
      "for": "chose_device"
    }
  }, [_vm._v(_vm._s(_vm.web_texts.device))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.device),
      expression: "device"
    }],
    staticClass: "form-control input-lg",
    attrs: {
      "id": "chose_device",
      "name": "chose_device",
      "size": "1",
      "disabled": !_vm.slave_type
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.device = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.web_texts.select_device))]), _vm._v(" "), _vm._l((_vm.devices), function(device) {
    return (device.type == 'CVM' || device.type == 'CVMNET' || device.type == 'CVMMINI') ? _c('option', {
      domProps: {
        "value": device
      }
    }, [_vm._v(_vm._s(device.name))]) : _vm._e()
  })], 2)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('div', {
    staticClass: "offset-lg-4 col-lg-4"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "disabled": _vm.spinner_invoice_simulation
    },
    on: {
      "click": function($event) {
        _vm.createInvoiceReports()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-dot-circle-o"
  }), _vm._v(" " + _vm._s(_vm.web_texts.create))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-danger",
    attrs: {
      "type": "reset",
      "disabled": _vm.spinner_invoice_simulation
    },
    on: {
      "click": function($event) {
        _vm.resetInvoiceForm()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v("Reset")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v(_vm._s(_vm.web_texts.invoice_simulation))])]), _vm._v(" "), (_vm.spinner_invoice_simulation) ? _c('GeneralSpinner') : _c('div', {
    staticClass: "card-block"
  }, [_c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.invoices,
      "paginate": true,
      "perPage": 5
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.row.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.name_slave))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.start_datetime))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.end_datetime))]), _vm._v(" "), _c('td', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_c('button', {
          staticClass: "btn btn-primary",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              _vm.downloadInvoice(props.row.id)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-file-pdf-o"
        })]), _vm._v(" "), _c('button', {
          staticClass: "btn btn-danger",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              _vm.deleteInformApi(props.row.id)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash-o"
        })])])]
      }
    }])
  })], 1)], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-prepend input-group col-xlg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('span', {
    staticClass: "add-on input-group-addon"
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-calendar fa fa-calendar"
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control input-lg",
    attrs: {
      "type": "text",
      "name": "daterange",
      "id": "daterange"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7927e9b4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/InvoiceSimulation.vue
// module id = 558
// module chunks = 1